import styled from 'styled-components';
import CrossIconSVG from './cross-icon.svg';

const CrossIcon = styled(CrossIconSVG as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2rem'};
  height: ${props => props.height || '2rem'};
  fill: ${props => props.fill || '#647a97'};
  
`;

export default CrossIcon;

